
import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 'standard-displaymessage',
    templateUrl: './standard-displaymessage.component.html'
})
export class StandardDisplayMessageComponent extends Overlay {
    
    message: any = {};
    response: any = {};
    userresp: any = {};
    isResponseEmpty : boolean = false;
    
    public FIELDS: string[] = ['message', 'response', 'userresp'];

    ngOnInit(){
        this.isResponseEmpty = Object.keys(this.response).length === 0; 
    }
}
